export const designHeight = 1080 // 设计稿 height
export const designWidth = 1920 // 设计稿 width

// 获取宽高比例
export const getScale = () => {
  const ww = window.innerWidth / designWidth
  const wh = window.innerHeight / designHeight
  const scale = ww < wh ? ww : wh
  const dWidth = window.innerWidth / scale
  const dHeight = window.innerHeight / scale
  // 目前缩放支持两种方案，一种是不等比（那么宽度和高度均可铺平。就是图片会出现拉伸的情况）
  return [scale, scale, dWidth, dHeight]
  // 另一种是等比，宽度可以铺平，但是高度在一些极端屏幕下会出现空白
  // return [ww, wh, dWidth]
}
